function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.667 13.607a.333.333 0 1 0 .666 0V5.056a.333.333 0 1 0-.666 0v8.551zM10.467 13.94h-.022a.334.334 0 0 1-.31-.355l.568-8.552a.34.34 0 0 1 .355-.31.334.334 0 0 1 .31.355l-.569 8.551a.333.333 0 0 1-.332.312zM5.2 13.63a.333.333 0 0 0 .333.31h.022a.334.334 0 0 0 .31-.355l-.568-8.552a.334.334 0 0 0-.665.044L5.2 13.63z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.801.891l.586 1.796H15.2a.333.333 0 1 1 0 .667h-1.053l-.896 12.363a.334.334 0 0 1-.332.31h-9.85a.333.333 0 0 1-.332-.31L1.84 3.353H.787a.333.333 0 1 1 0-.666H5.6L6.185.89a.333.333 0 0 1 .317-.23h2.981c.145 0 .272.093.317.23zm-.559.437l.443 1.359H6.301l.444-1.359h2.497zM12.61 15.36h-9.23l-.87-12.005h10.97l-.87 12.005z",
  fill: "#fff"
});

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "2b596e3b483994800bb71e2dce1d3b31.svg";
export { SvgTrash as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/trash.svg
// module id = null
// module chunks = 